<script>
	import Calendar from "./programme/Calendar.svelte";
	import Explorers from "./programme/Explorers.svelte";
	import Scouts from "./programme/Scouts.svelte";
	import Default from "./programme/Default.svelte";

	export let sectionName = "";
	export let defaultUniform = "Full Uniform";
	export let url = "url";
</script>

<svelte:head>
	<link rel="preconnect" href="https://fonts.googleapis.com">
	<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
	<link href="https://fonts.googleapis.com/css2?family=Nunito+Sans:wght@400;700;900&display=swap" rel="stylesheet">
	<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css">
	<style>
		@media print {
			@page { margin: 0; }
		}
	</style>
</svelte:head>

<div id="page-wrap">
	<div id="header">
		<div id="heading">
			<h2>#Programme</h2>
			<h1>{sectionName}</h1>
		</div>
		<img src="./img/logo.png" alt="1st Hazel Grove Scout Group" />
	</div>

	<table id="items">
		<tr>
			<th>Date</th>
			<th>Activity</th>
			<th>Uniform</th>
			<th>Time</th>
		</tr>
		<Calendar {defaultUniform} {url} />
	</table>

	{#if sectionName === 'Explorers'}
		<Explorers />
	{:else if sectionName === 'Scouts'}
		<Scouts />
	{:else}
		<Default />
	{/if}

</div>

<style>
	* {
		font-family: "Nunito Sans", sans-serif;
	}
	#page-wrap {
		width: 800px;
		min-height: 800px;
		margin: 0 auto;
		background: #fff;
	}
	#header {
		height: 130px;
		width: 100%;
	}
	#header > img {
		float: right;
		padding: 0;
	}
	#heading {
		float: left;
		padding: 50px 0;
	}
	#heading > h1,
	h2 {
		font-size: 24pt;
		font-weight: 900;
		padding: 0 15px;
		margin: 0;
	}
	#heading > h1 {
		color: #006ddf;
		margin-top: -14px;
	}
	#heading > h2 {
		color: #003982;
	}
	#items {
		width: 100%;
		border: solid 1px black;
		margin: 0 auto;
		width: 95%;
		border-collapse: collapse;
	}

	th {
		border: solid 1px black;
	}
</style>
